import React, {useContext} from "react";
import {Fade, Stack} from "@mui/material";
import {Context as AppContext} from "../../../../context/AppContext";
import {RAIL, rgba} from "./rail/railTokens";
import {FlowBlock} from "./blocks/FlowBlock";
import {IntentBlock} from "./blocks/IntentBlock";
import {EntityBlock} from "./blocks/EntityBlock";
import {SkillsBlock} from "./blocks/SkillsBlock";
import {WatchdogsBlock} from "./blocks/WatchdogsBlock";
import {ConstsBlock} from "./blocks/ConstsBlock";
import {TagsBlock} from "./blocks/TagsBlock";

export {ListBlock} from "./blocks/ListBlock";

export const SideMenu = ({flows, selectedFlow, project, onSelectFlow}) => {
    const {updateProject, getUserProjects} = useContext(AppContext);

    const shared = {project, onUpdateProject: updateProject, getUserProjects};

    return (
        <Fade in={!!project} timeout={500}>
            <Stack
                direction="column"
                sx={{
                    maxHeight: "100%",
                    maxWidth: 280,
                    width: "100%",
                    py: 0.5,
                    backgroundColor: RAIL.surface,
                    borderRight: `1px solid ${rgba(RAIL.accent, 0.12)}`,
                    overflowY: "auto",
                }}
            >
                <FlowBlock {...shared} flow={selectedFlow} onSelectFlow={onSelectFlow}/>
                <IntentBlock {...shared} flow={selectedFlow}/>
                <EntityBlock {...shared} flow={selectedFlow}/>
                <SkillsBlock {...shared}/>
                <WatchdogsBlock {...shared}/>
                <ConstsBlock {...shared}/>
                <TagsBlock {...shared}/>
            </Stack>
        </Fade>
    );
};
